import { Id } from "@dgs/core";
import { DataFieldOptionIndexResource } from "./dataFieldOption";

export enum DataFieldType {
	TEXT = "text",
	LONG_TEXT = "longText",
	EMAIL = "email",
	NUMBER = "number",
	URL = "url",
	RADIO = "radioField",
	SELECT_FIELD = "selectField",
	MULTI_SELECT_FIELD = "multiSelectField",
	CHECKBOX = "checkbox",
	CHECKBOX_GROUP = "checkboxGroup",
	DATE = "date",
	TIME = "time",
	DATETIME = "dateTime",
	PHONE = "phone",
}

export interface DataFieldIndexResource {
	id: Id;
	label: string;
	type: DataFieldType;
	options: DataFieldOptionIndexResource[];
	placeholder?: string;
	description?: string;
}

export interface DataFieldOptionResource {
	id: Id;
	label: string;
}
